module.exports = __webpack_public_path__ + "img/24m-garantie-banner-nl.71a8fe52.jpg";